import { render, staticRenderFns } from "./SectionFactorUseFrom2025.vue?vue&type=template&id=7a0bc820"
import script from "./SectionFactorUseFrom2025.vue?vue&type=script&lang=ts"
export * from "./SectionFactorUseFrom2025.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports